
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Container adaptive column fixed" fileName="column-fixed-auto-width.md" />
        <demo-block>
        <div><p>1、Set the width of the scroll area through <code>scroll-width=&quot;1600&quot;</code><br>2、The outer container width is not set. Equivalent to settings <code>style=&quot;width:100%&quot;</code><br>3、Try changing the browser width.When the container width is less than <code>scroll-width</code>, the scroll bar will appear；When it is greater than <code>scroll-width</code>, it will follow the container adaptation</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        :scroll-width=&quot;1600&quot;
        border-y
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        rowKeyFieldName=&quot;rowKey&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    { field: &quot;col1&quot;, key: &quot;a&quot;, title: &quot;Title1&quot;, fixed: &quot;left&quot; },
                    { field: &quot;col2&quot;, key: &quot;b&quot;, title: &quot;Title2&quot;, fixed: &quot;left&quot; },
                    { field: &quot;col3&quot;, key: &quot;c&quot;, title: &quot;Title3&quot; },
                    { field: &quot;col4&quot;, key: &quot;d&quot;, title: &quot;Title4&quot; },
                    { field: &quot;col5&quot;, key: &quot;e&quot;, title: &quot;Title5&quot; },
                    { field: &quot;col6&quot;, key: &quot;f&quot;, title: &quot;Title6&quot; },
                    { field: &quot;col7&quot;, key: &quot;g&quot;, title: &quot;Title7&quot; },
                    { field: &quot;col8&quot;, key: &quot;h&quot;, title: &quot;Title8&quot; },
                    {
                        field: &quot;col9&quot;,
                        key: &quot;i&quot;,
                        title: &quot;Title9&quot;,
                        fixed: &quot;right&quot;,
                    },
                    {
                        field: &quot;col10&quot;,
                        key: &quot;j&quot;,
                        title: &quot;Title10&quot;,
                        fixed: &quot;right&quot;,
                    },
                ],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 10; i++) {
                    data.push({
                        rowKey: i,
                        col1: i,
                        col2: i,
                        col3: i,
                        col4: i,
                        col5: i,
                        col6: i,
                        col7: i,
                        col8: i,
                        col9: i,
                        col10: i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"scroll-width":1600,"border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"rowKeyFieldName":"rowKey"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    { field: "col1", key: "a", title: "Title1", fixed: "left" },
                    { field: "col2", key: "b", title: "Title2", fixed: "left" },
                    { field: "col3", key: "c", title: "Title3" },
                    { field: "col4", key: "d", title: "Title4" },
                    { field: "col5", key: "e", title: "Title5" },
                    { field: "col6", key: "f", title: "Title6" },
                    { field: "col7", key: "g", title: "Title7" },
                    { field: "col8", key: "h", title: "Title8" },
                    {
                        field: "col9",
                        key: "i",
                        title: "Title9",
                        fixed: "right",
                    },
                    {
                        field: "col10",
                        key: "j",
                        title: "Title10",
                        fixed: "right",
                    },
                ],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 10; i++) {
                    data.push({
                        rowKey: i,
                        col1: i,
                        col2: i,
                        col3: i,
                        col4: i,
                        col5: i,
                        col6: i,
                        col7: i,
                        col8: i,
                        col9: i,
                        col10: i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  